import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <div className="text-6xl font-bold text-gray-900 mb-4">404</div>
      <div className="text-xl text-gray-600 mb-8">{t('general.notFound')}</div>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-secondary font-medium transition-colors"
      >
        {t('general.backToLogin')}
      </button>
    </div>
  );
}
